import Card from "@mui/material/Card";
import React, { useEffect, useState } from "react";
import "./finalisefs.css";
import swal from 'sweetalert';

import { FormControl, InputLabel, Select, MenuItem } from "@mui/material";
import AddFooters from "./footers";
import { motion } from "framer-motion";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import Sidebar from "../../myfin_v2/elements/Sidebar"
import commoncss from "../../myfin_v2/css/common.module.css"
import buttoncss from "../../myfin_v2/css/button.module.css"
import standalonecss from "../../myfin_v2/css/standalone.module.css"
import bookclosuretablecss from "../../myfin_v2/css/bookclosuretable.module.css";
import CreatePackageModal from "../../myfin_v2/components/bookclosure/CreatePackageModal";
import { Button } from "../../myfin_v2/elements/Button";
import Breadcrumb from "../../myfin_v2/components/Breadcrumb";
import { ReactComponent as PlusIcon } from "../../myfin_v2/assets/icons/plusBlack.svg";
import adminPortalCss from "../../myfin_v2/css/adminportal.module.css";
import InputGroup from "../../myfin_v2/elements/InputGroup";
import { finalizeFSFormatApiHandler, getFinalizeFSApiHandler, getPopulateFSExportFSApiHandler } from "../../WorkSpace/Components/ApiServices/apiHandler";
import AddSignature from "./AddSignature";
// import "./finalisefs.css";

const label = { inputProps: { "aria-label": "Checkbox demo" } };

const FinaliseFs = () => {
  const [headers, setHeaders] = useState([]);
  const [footers, setFooters] = useState([]);

  const project_id = localStorage.getItem("project_id");
  // const project_id = "6926c0af2325c750306470a0";


  const units_values = [
    "whole numbers",
    "hundreds",
    "thousands",
    "lakhs",
    "crores",
    "millions",
  ];
  const decimal_values = [0, 1, 2, 3];

  const [unit, setUnit] = useState(null);
  const [decimal, setDecimal] = useState(null);
  const [checkBoxList, setCheckBoxList] = useState([{ label: "BS", value: "BS" },
  { label: "PL", value: "PL" },
  { label: "BS notes", value: "BS notes" },
  { label: "PL notes", value: "PL notes" },
  { label: "Cashflow", value: "cashflow" },
  { label: "SOCIE", value: "socie" },
  { label: "Disclosure", value: "disclosure" },
  { label: "Disclosure Checklist", value: "disclosure checklist" },
  { label: "General notes", value: "general notes" }])

  const breadcrumbItems = [
    { link: "/myfinV2/standalonefs" },
    { label: "Finalise your Financial Statements", link: "", className: "headerLable" },
  ];


  const [selectedFooters, setSelectedFooters] = useState([]);
  const [showAddSignatureModal, setShowAddSignatureModal] = useState(false);

  const handleUnitDecimal = (e) => {
    if (e.target.name === "unit") {
      setUnit(e.target.value);
    } else {
      setDecimal(e.target.value);
    }
  };



  const exportFS = (exportAs) => {
    const params = {
      projectID: project_id,
      fileType: exportAs,
    };

    getPopulateFSExportFSApiHandler(params)
      .then((response) => {
        const blob = new Blob(
          [response.data],
          {
            type:
              exportAs === "pdf"
                ? "application/pdf"
                : "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet"
          }
        );

        const fileUrl = window.URL.createObjectURL(blob);
        const downloadLink = document.createElement("a");
        downloadLink.href = fileUrl;

        downloadLink.download =
          exportAs === "pdf"
            ? `FS_${project_id}.pdf`
            : `FS_${project_id}.xlsx`;

        document.body.appendChild(downloadLink);
        downloadLink.click();

        downloadLink.remove();
        window.URL.revokeObjectURL(fileUrl);
      })
      .catch((error) => {
        console.error("exportFS error:", error);
      });
  };

  const [formData, setFormData] = useState({
    "_id": null,
    "category": null,
    "firmName": null,
    "firmRole": null,
    "firmNumber": null,
    "auditorName": null,
    "auditorRole": null,
    "membershipNumber": null,
    "place": null,
    "date": null
  })

  const [directorsForm, setDirectorsForm] = useState({
    "_id": null,
    "category": null,
    "firmName": null,
    "firmRole": null,
    "firmNumber": null
  })

  useEffect(() => {
    console.log("unit,decimal,selectedFooters", unit, decimal, selectedFooters);
    if (unit && decimal) {
      handleFSFormat();
    }
  }, [unit, decimal, selectedFooters])
  useEffect(() => {
    getFinalizeFSApiHandler(project_id).then(response => {
      const finalizeFSFormat = response.data.finalizeFSFormat
      const signatoryList = response.data.signatoryList
      console.log("finalizeFSFormat", finalizeFSFormat);
      setUnit(finalizeFSFormat?.units ?? null)
      setDecimal(finalizeFSFormat?.decimals ?? null)
      setSelectedFooters(finalizeFSFormat?.selectedPages ?? [])
    }).catch(error => {
      swal("Error", "Error: Get Finalize FS API Failed!", "error");
    })
  }, [])

  const handleFSFormat = () => {

    const payload = {
      finalizeFSFormat: {
        units: unit,
        decimals: decimal,
        addFooterTo: selectedFooters
      },
    };

    console.log("payload", payload);

    finalizeFSFormatApiHandler({ projectID: project_id }, payload)
      .then((response) => {
        if (response?.data?.success === true) {
        } else {
          swal(
            "Error",
            response?.data?.error || "Unable to update Finalise FS format",
            "error"
          );
        }
      })
      .catch((error) => {
        swal(
          "Error",
          error?.response?.data?.error || "Unable to update  Finalise FS format",
          "error"
        );
      });
  };
  return (
    <>
      <div className={commoncss.pageLayout}>
        <Sidebar />
        <div className={`d-flex ${commoncss.pageContent}`}>
          <motion.div
            initial={{ x: -100, opacity: 0 }}
            animate={{ x: 0, opacity: 1 }}
            exit={{ x: 0, opacity: 0 }}
            transition={{ duration: 0.5, ease: "easeInOut" }} className={commoncss.w100} style={{ maxHeight: "95vh", overflowY: "hidden" }} >
            {/* <BookcluosureNav bookClosureId={bookClosureId} setCreatePackageModal={setCreatePackageModal} setSavePresetModal={setSavePresetModal} selectedEntries={selectedEntries} entries={entries} /> */}
            <div className="fscp-header">
              <Breadcrumb style="margin-right:auto"
                addCls={"bgClr1"}
                items={breadcrumbItems}
                headerActions={<></>}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as Excel"
                onClick={() => { exportFS("excel") }}
              />
              <Button
                btnColor={buttoncss.secondary}
                class_={buttoncss.greyBg}
                label="Export as PDF"
                onClick={() => { exportFS("pdf") }}
              />
            </div>

            <div className="mx-3">
              <div className={standalonecss.finaliseFSDiv}
              >
                <div className="d-flex mt-4 ml-3" style={{ gap: "10px" }}>
                  <div
                    style={{
                      display: "flex",
                      flexDirection: "column",
                      width: "210px",
                    }}
                  >
                    <FormControl fullWidth>
                      <InputLabel id="unit-value-select-label"
                        sx={{
                          "&.Mui-focused": {
                            color: "#B3C0BD",
                          },
                          fontSize: "14px",
                          marginTop: '-5px',
                          fontWeight: "500",
                          color: "#B3C0BD"
                        }}>
                        Units
                      </InputLabel>
                      <Select
                        labelId="unit-value-select-label"
                        id="unit-value-select"
                        value={unit}
                        label="Units"
                        name="unit"
                        onChange={handleUnitDecimal}
                        IconComponent={ExpandMoreIcon}
                        sx={{
                          width: "200px",
                          height: "40px",
                          padding: '10px',
                          paddingLeft: '0px',
                          backgroundColor: "#F4FAF5",
                          borderRadius: "10px",
                          fontSize: "14px",
                          "& .MuiSelect-select": {
                            display: "flex",
                            alignItems: "center",   // vertical center
                            padding: "0 12px",      // nice left/right padding
                            height: "100%",         // make it stretch to match height
                          },
                          "& .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&:hover .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                          "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                            borderColor: "#C2E6D1",
                          },
                        }}
                      >
                        {units_values.map((item, key) => (
                          <MenuItem value={item} key={key}>
                            {item}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                  </div>
                  <div>
                    <div
                      style={{
                        display: "flex",
                        flexDirection: "column",
                        width: "250px",
                      }}
                    >
                      <FormControl fullWidth>
                        <InputLabel id="decimal-value-select-label"
                          sx={{
                            "&.Mui-focused": {
                              color: "#B3C0BD",
                            },
                            fontSize: "14px",
                            marginTop: '-5px',
                            fontWeight: "500",
                            color: "#B3C0BD"
                          }}>
                          Decimals
                        </InputLabel>
                        <Select
                          labelId="decimal-value-select-label"
                          id="decimal-value-select"
                          value={decimal}
                          label="Decimals"
                          name="decimal"
                          onChange={handleUnitDecimal}
                          IconComponent={ExpandMoreIcon}
                          sx={{
                            width: "200px",
                            height: "40px",
                            padding: '10px',
                            paddingLeft: '0px',
                            backgroundColor: "#F4FAF5",
                            borderRadius: "10px",
                            fontSize: "14px",
                            "& .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&:hover .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                            "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                              borderColor: "#C2E6D1",
                            },
                          }}
                        >
                          {decimal_values.map((item, key) => (
                            <MenuItem value={item} key={key}>
                              {item}
                            </MenuItem>
                          ))}
                        </Select>
                      </FormControl>
                    </div>
                  </div>
                </div>

                <div className="p-3">
                  <Card className="pb-2" style={{ borderRadius: "10px", border: "1px solid #CCD5D3" }}>
                    <div className={standalonecss.finaliseFSSecHeader}
                    >
                      <span className={`ml-3 ${commoncss.fs15} ${commoncss.fw600}`}>Footer</span>
                    </div>
                    <AddFooters
                      checkBoxList={checkBoxList}
                      selectedItems={selectedFooters}
                      setSelectedItems={setSelectedFooters}
                    />
                    <div className={`ml-3 ${commoncss.clickable}`} onClick={() => { setShowAddSignatureModal(true) }}>
                      <PlusIcon height={18} width={18} /> &nbsp;<span className={`${commoncss.textLabel} ${commoncss.fs15}`}>Add Signature</span>
                    </div>
                  </Card>
                </div>
              </div>
            </div>
            {showAddSignatureModal && <AddSignature setShowAddSignatureModal={setShowAddSignatureModal} formData={formData} setFormData={setFormData} />}
          </motion.div>
        </div >
      </div >
    </>
  );
};

export default FinaliseFs;
